import React from "react";
import AppContainer from "../../AppContainer";
import classnames from "classnames";
import { map } from "lodash";
import Button from "../../Button";
import LearnMoreIcon from "../../icons/LearnMore.svg";
import TableIcon from "../../icons/Table.svg";
import LABELS from "../../labels";
import { setParams } from "../../../utils/location"
import * as styles from "./index.module.scss";

const CallToActionButtons = ({
  appStyles,
  split,
  showRestaurantInteractionBlock,
  enableFeedback,
  showGiftCard,
  T,
  homepageShowTiersList,
  className,
}) => {
  return (
    <AppContainer.AttachedContent
      classNames={classnames({
        [styles.MobileBottomButtons]: Boolean(split),
        [styles.TopSideMobileButtons]: !Boolean(split), 
      }, className)}
      style={homepageShowTiersList ? { position: "relative" } : {}}
    >
      {map(appStyles.externalLinks, (link, indx) => (
        <Button
          key={link + indx}
          slim
          centered
          appStyles={appStyles}
          isExternalLink
          to={link.href}
          classNames={styles.ButtonWithIcon}
        >
          {T(link.label)}
          {link.useLearnMoreIcon ? <LearnMoreIcon /> : <TableIcon />}
        </Button>
      ))}
      {showRestaurantInteractionBlock && (
        <>
          {enableFeedback &&
            (appStyles.contactUsAlternative?.href ? (
              <Button
                slim
                centered
                appStyles={appStyles}
                isExternalLink
                to={appStyles.contactUsAlternative.href}
                // classNames={styles.ButtonWithIcon}
              >
                {T(
                  appStyles.contactUsAlternative.label || LABELS.CONTACT_US
                )}
              </Button>
            ) : (
              <Button appStyles={appStyles} to="/contact-us" centered slim>
                {T(LABELS.CONTACT_US)}
              </Button>
            ))}
          {showGiftCard && (
            <Button
              appStyles={appStyles}
              to={setParams("/gift-card", { onCloseTarget: "/" })}
              centered
              slim
            >
              {T("Send a Gift Card")}
            </Button>
          )}
        </>
      )}
    </AppContainer.AttachedContent>
  );
};

export default CallToActionButtons;